export default "__VITE_ASSET__DrJAKtQA__"